import React, { useState, useEffect } from 'react'
import { NodeLinkGraph } from './data-viz/NodeLinkGraph';
import { Modal } from 'semantic-ui-react';
import axios from 'axios';
import { BASE_URL } from '../../config/config';

import GraphImage from '../../assets/images/graph-img.png';
import './data-viz/value-chain-graph-area.scss';

const dataVizButtons = [
    { label: 'Tree graph visualization', value: 'NODE_LINK', image: GraphImage }
]

export const DataVisualizations = (props) => {
    const { productId, applications = [], applicationsCount = 0, product = {} } = props;

    const [open, setOpen] = useState(false);
    const [selectedViz, setSelectedViz] = useState('');
    const [valueChainProduct, setValueChainProduct] = useState(null);

    useEffect(() => {
        if (!productId) return undefined;
        let cancelled = false;
        axios
            .get(`${BASE_URL}/api/v1/product/${productId}?value_chain=true`, { withCredentials: true })
            .then((res) => {
                if (!cancelled && res.data && res.data.Item) {
                    setValueChainProduct(res.data.Item);
                }
            })
            .catch(() => { });
        return () => {
            cancelled = true;
        };
    }, [productId]);

    const graphProduct = valueChainProduct || product;

    const handleButtonClick = (value) => {
        setSelectedViz(value);
        setOpen(true);
    }

    const handleCloseClick = () => {
        setSelectedViz('');
        setOpen(false)
    }

    const getComponent = () => {
        switch (selectedViz) {
            case 'NODE_LINK':
                return (
                    <div className="value-chain-area value-chain-area-tab">
                        <NodeLinkGraph
                            applications={applications}
                            from="new"
                            applicationsCount={applicationsCount}
                            product={graphProduct}
                            width="100%"
                        />
                    </div>
                );
            default: return null;
        }
    }

    const getTitle = () => {
        switch (selectedViz) {
            case 'NODE_LINK': return 'Node Link Diagram'
            default: return null;
        }
    }

    return (
        <span>
            <div className="supplierslist-wrapper border-1-radius">
                <div className='visualiz-listing'>
                    {dataVizButtons.map(({ label, value, image }) => (
                        <div className='card-box' key={value} onClick={() => handleButtonClick(value)}>
                            <div className='card-upper'>
                                <img src={image} />
                            </div>
                            <div className='card-bottom'>
                                <p>{label}</p>
                            </div>
                        </div>
                    ))}
                </div>
                <Modal
                    className="createa-supplier"
                    onClose={handleCloseClick}
                    open={open}
                    size="fullscreen"
                    closeIcon
                >
                    <Modal.Content>
                        <Modal.Description>
                            <div className="mb-3"><b>{getTitle()}</b></div>
                            {getComponent()}
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
            </div>
        </span>
    )
}
